export default __webpack_public_path__ + "static/media/funeral.4c23a060.mp4";